import Table from '@material-ui/core/Table'
import TableContainer from '@material-ui/core/TableContainer'
import TablePagination from '@material-ui/core/TablePagination'
import React from 'react'
import { TABLE_TYPE, useQueryToTableProvider, useTableContext } from '../../context/TableContext'
import Loading from '../../customs/Loading/Loading'
import Error from '../../parts/Error'
import Info from '../../parts/Info'
import { useTableStyles } from './styles'
import { TableBodyRender } from './TableBodyRender'
import { TableCheckedActions } from './TableCheckedActions'
import { TableHeadRender } from './TableHeadRender'
import { TableToolbar } from './TableToolbar'

export interface TableHeadCell {
  id: string;
  label: string;
}

interface iSortTable {
  heads: TableHeadCell[],
  data: Array<any>,
  cellDate?: string,
  cellAttach?: string,
  cellState?: string,
  totalCount?: number,
  noFilter?: boolean,
  loading: boolean,
  error: string,
}

export const MsgsTable = ({
  heads,
  data,
  cellDate = 'deliveredAt',
  cellAttach = 'attachment',
  cellState = 'state',
  totalCount,
  noFilter = false,
  loading,
  error
}: iSortTable) => {
  const classes = useTableStyles()

  const { state: { page, limit }, updateState, type } = useTableContext()

  const withChecked = !noFilter && [TABLE_TYPE.IN, TABLE_TYPE.OUT].includes(type)
  useQueryToTableProvider()

  const handleChangePage = (event: unknown, newPage: number) => {
    const toPage = newPage + 1
    updateState({ page: toPage })
  }

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    const limit = parseInt(event.target.value, 10)
    updateState({ limit: limit, page: 1 })
  }
  const TableRender = () => {
    if (loading) {
      return noFilter ?
        <div style={{ position: 'relative', marginTop: -30, marginLeft: -55, height: 150 }}><Loading/></div> :
        <Loading/>
    }
    if (error) {
      return <Error>{error}</Error>
    }
    if (data === undefined || data.length === 0) {
      return <Info>Žádné zprávy</Info>
    }

    return (
      <TableContainer>
        <Table
          className={classes.table}
          aria-labelledby="tableTitle"
          size={'small'}
          aria-label="enhanced table"
        >
          <TableHeadRender heads={heads} withChecked={withChecked}/>
          <TableBodyRender heads={heads}
                           data={data}
                           withChecked={withChecked}
                           cellAttach={cellAttach}
                           cellDate={cellDate}
                           cellState={cellState}/>
        </Table>
      </TableContainer>
    )
  }

  return (
    <div className={classes.root}>
      {!noFilter &&
        <TableToolbar/>
      }
      {withChecked &&
        <TableCheckedActions data={data}/>
      }
      <TableRender/>
      {(data !== undefined && data.length !== 0 && !error) &&
        <TablePagination
          count={totalCount || 0}
          onPageChange={handleChangePage}
          page={page - 1}
          rowsPerPage={limit}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[20, 50]}
          component="div"
          labelRowsPerPage="Počet na stránku"
          labelDisplayedRows={
            ({ from, to, count }) => {
              return `${from}-${to} z ${count}`
            }
          }
        />
      }
    </div>
  )
}
